<template>
  <div>
    <div
      v-if="searchShow"
      @click="searchShow = false"
      class="fixed z-40 inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
    ></div>

    <div
      class="header-title w-full flex-1 border-b  p-2 flex items-center justify-between"
    >
      <div class="flex items-center space-x-2  justify-start">
        <vk-icon-button
          class="back-icon"
          @click="$router.push('/')"
          icon="home"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          @click="$root.back()"
          icon="chevron-left"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          v-if="favorite"
          @click="favoriteAdd(favorite)"
          icon="heart"
        ></vk-icon-button>
        <vk-icon-button
          class="back-icon"
          v-if="favorite"
          @click="nextLead()"
          icon="chevron-right"
        ></vk-icon-button>
        <h2 class="text-xl font-bold my-0">{{ title }}</h2>
      </div>

      <div v-if="searchShow == false" class=" ">
        <form
          class="flex items-center"
          @submit="searchSubmit()"
          action="javascript:void(0)"
        >
          <div style="margin-top:3px;margin-left: 10px; position: absolute">
            <transition name="fade">
              <vk-icon icon="close" v-if="searchValue" @click="searchClear()" />
              <vk-icon v-else @click="searchSubmit()" icon="search" />
            </transition>
          </div>

          <input
            class="w-10 md:w-72 rounded-lg border-gray-200 text-xs border p-2"
            @click="showSearchSet()"
            style="margin-right: 0px; text-indent: 35px"
            type="search"
            placeholder="Aranacak kelime, kısayol ctrl+k"
          />
        </form>
      </div>
    </div>

    <div v-if="searchShow">
      <div class="fixed inset-0 z-40 overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8
             sm:w-full sm:max-w-lg"
          >
            <div class="bg-white  ">
              <div class=" sm:items-start">
                <div
                  class="flex p-2 bg-gray-50 border-b items-center justify-between space-x-2"
                >
                  <div>
                    <svg class="w-8 h-8" viewBox="0 0 32 32">
                      <path
                        fill="currentColor"
                        d="m29 27.586l-7.552-7.552a11.018 11.018 0 1 0-1.414 1.414L27.586 29ZM4 13a9 9 0 1 1 9 9a9.01 9.01 0 0 1-9-9Z"
                      />
                    </svg>
                  </div>
                  <input
                    class="border-gray-50 border focus:border-transparent focus:ring-0  ring-0 w-full text-xl  p-2 bg-gray-50   "
                    v-model="searchValue"
                    type="text"
                    @keyup.enter="keyEnter($event)"
                    id="rootsearch"
                    placeholder="Aranacak kelime"
                  />

                  <div @click="searchOnlyClear()">
                    <svg class="w-8 h-8" viewBox="0 0 24 24">
                      <path
                        fill="currentColor"
                        d="M6.4 19L5 17.6l5.6-5.6L5 6.4L6.4 5l5.6 5.6L17.6 5L19 6.4L13.4 12l5.6 5.6l-1.4 1.4l-5.6-5.6Z"
                      />
                    </svg>
                  </div>
                </div>

                <div class="flex p-2">
                  <div v-if="noResults && searchValue" class="flex-1 text-center text-gray-500 py-4">
                    Sonuç bulunamadı
                  </div>
                  <div v-else-if="lead_id > 0" class="flex-1">
                    <div
                      class="border-b flex mb-2  p-2 items-center justify-between "
                      :key="search.id"
                      v-for="search in searchResults"
                      v-if="search.id == lead_id"
                    >
                      <span @click="lead_id = 0">
                        <svg class="w-6 h-6" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M16 22L6 12L16 2l1.775 1.775L9.55 12l8.225 8.225Z"
                          />
                        </svg>
                      </span>

                      <div @click="setLeadId(search.id)">{{ search.name }}</div>
                      <div class="flex space-x-2 items-center">
                        <div v-if="search.utm_source" class="text-xs text-gray-500">{{ search.utm_source }}</div>
                        <div>{{ $root.getVal(15, search.agent_id) }}</div>
                        <div v-if="search.is_customer == 1">
                          <svg xmlns="http://www.w3.org/2000/svg"
                          title="Müşteri" alt="Müşteri" class="w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="M12 13q-1.65 0-2.825-1.175T8 9V5.5q0-.625.438-1.062T9.5 4q.375 0 .713.175t.537.5q.2-.325.538-.5T12 4t.713.175t.537.5q.2-.325.538-.5T14.5 4q.625 0 1.063.438T16 5.5V9q0 1.65-1.175 2.825T12 13m0-2q.825 0 1.413-.587T14 9V6.5h-4V9q0 .825.588 1.413T12 11M4 21v-2.8q0-.85.438-1.562T5.6 15.55q1.55-.775 3.15-1.162T12 14t3.25.388t3.15 1.162q.725.375 1.163 1.088T20 18.2V21zm2-2h12v-.8q0-.275-.137-.5t-.363-.35q-1.35-.675-2.725-1.012T12 16t-2.775.338T6.5 17.35q-.225.125-.363.35T6 18.2zm6-12.5"/></svg>
                        </div>

                        <a target="_blank" :href="'/leadDetail/' + search.id"
                          ><span style="font-size: 11px" class="green-button"
                            >DETAY</span
                          ></a
                        >
                      </div>
                    </div>

                    <Notes
                      class="w-full"
                      table="crm_notes"
                      field="leadId"
                      selectedStatus="1"
                      :id="lead_id"
                    />
                  </div>
                  <div v-else class="flex-1">
                    <div
                      v-if="searchResults"
                      class="border-b flex cursor-pointer p-2 items-center justify-between "
                      :key="search.id"
                      v-for="search in searchResults"
                    >
                      <div @click="setLeadId(search.id)">{{ search.name }}</div>
                      <div class="flex justify-between items-center space-x-2">
                        <div v-if="search.utm_source" class="text-xs text-gray-500">{{ search.utm_source }}</div>
                        <div>{{ $root.getVal(15, search.agent_id) }}</div>
                        <div v-if="search.is_customer == 1">
                          <svg xmlns="http://www.w3.org/2000/svg"
                          title="Müşteri" alt="Müşteri" class="w-4 h-4" viewBox="0 0 24 24"><path fill="currentColor" d="M12 13q-1.65 0-2.825-1.175T8 9V5.5q0-.625.438-1.062T9.5 4q.375 0 .713.175t.537.5q.2-.325.538-.5T12 4t.713.175t.537.5q.2-.325.538-.5T14.5 4q.625 0 1.063.438T16 5.5V9q0 1.65-1.175 2.825T12 13m0-2q.825 0 1.413-.587T14 9V6.5h-4V9q0 .825.588 1.413T12 11M4 21v-2.8q0-.85.438-1.562T5.6 15.55q1.55-.775 3.15-1.162T12 14t3.25.388t3.15 1.162q.725.375 1.163 1.088T20 18.2V21zm2-2h12v-.8q0-.275-.137-.5t-.363-.35q-1.35-.675-2.725-1.012T12 16t-2.775.338T6.5 17.35q-.225.125-.363.35T6 18.2zm6-12.5"/></svg>
                        </div>

                        <a target="_blank" :href="'/leadDetail/' + search.id"
                          ><span style="font-size: 11px" class="green-button"
                            >DETAY</span
                          ></a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "../../services/http";
import NotesVue from "../PageBuilder/Notes.vue";
import EventBus from "./EventBus";

export default {
  props: ["title", "favorite", "nextLeadId"],
  name: "topsearch",
  data() {
    return {
      searchShow: false,
      searchValue: null,
      lead_id: 0,
      searchTable: "leads",
      searchResults: [],
      activeIndex: 0,
      noResults: false,
      searchTimer: null,
      searchRequestId: 0,
    };
  },
  mounted() {
    if (this.title) {
      document.title = this.title;
    }
    EventBus.$on("topSearchFocus", (data) => {
      this.searchShow = true;
      setTimeout(() => {
        document.getElementById("rootsearch").focus();
      }, 10);
    });
  },
  watch: {
    // Her tuşta istek atılıyordu; sunucuda LIKE '%..%' ile leads taranıyor.
    // Yazma durunca tek istek gider (Enter doğrudan listeye gittiği için
    // beklemeden etkilenmez).
    searchValue() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.runSearch(), 300);
    },
  },
  beforeDestroy() {
    clearTimeout(this.searchTimer);
  },
  components: {
    Notes: NotesVue,
  },
  methods: {
    runSearch() {
      const requestId = ++this.searchRequestId;
      http.getSearchPhone({ keyword: this.searchValue }).then((resp) => {
        // Yanıtlar sırasız gelebilir; eski aramanın sonucu yenisinin üstüne
        // yazmasın.
        if (requestId !== this.searchRequestId) return;
        if (resp.data.success == true) {
          this.lead_id = 0;
          this.searchResults = resp.data.results;
          this.noResults = false;
        } else {
          this.lead_id = 0;
          this.searchResults = [];
          this.noResults = true;
        }
      });
    },
    showSearchSet() {
      this.searchShow = true;
      setTimeout(() => {
        document.getElementById("rootsearch").focus();
      }, 100);
    },
    keyP(e) {
      if (e.key == "ArrowDown") {
        if (this.activeIndex < this.searchResults.length - 1) {
          this.activeIndex++;
        }
      } else {
        if (this.activeIndex > 0) {
          this.activeIndex--;
        }
      }
    },
    setLeadId(leadId) {
      EventBus.$emit("getNote");
      this.lead_id = leadId;
    },
    keyEnter() {
      this.searchSubmit();
    },
    boldla(e, k) {
      return e
        .toString()
        .toLowerCase()
        .replace(k.toLowerCase(), "<b>" + k.toLowerCase() + "</b>");
    },
    searchClear() {
      this.searchValue = "";
      this.searchSubmit();
    },

    favoriteAdd(favoriData) {
      http.addFavorite(favoriData).then((resp) => {
        EventBus.$emit("favoritesLoad");
      });
    },
    nextLead() {
      if (this.nextLeadId) {
        location.href = "/leadDetail/" + this.nextLeadId;
        return;
      }
      // Eskiden tıklama sessizce bir şey yapmıyordu. false: henüz
      // hesaplanıyor, null: listenin sonu.
      EventBus.$emit("bottomMessage", {
        open: true,
        type: "info",
        title: "Sonraki kayıt",
        duration: 3000,
        body:
          this.nextLeadId === null
            ? "Listenin sonuna geldiniz."
            : "Sonraki kayıt hesaplanıyor, birazdan tekrar deneyin.",
      });
    },
    searchOnlyClear() {
      this.searchValue = "";
      this.searchShow = false;
      this.searchResults = [];
      this.noResults = false;
    },
    searchSubmit() {
      this.lead_id = 0;
      if (this.searchValue == null) {
        this.searchValue = "";
      }
      this.$router.push(
        "/list/" + this.searchTable + "/?name=" + this.searchValue,
        () => {}
      );
      this.searchShow = false;
    },
  },
};
</script>

<style></style>
